export default __webpack_public_path__ + "static/media/Trinity.fe7ef540.webp";